import { Check } from "lucide-react";

import { cn } from "@/utils/cn";

const ALPHA_STEPS = ["Prompt", "Styles", "Review", "Download"] as const;

export type AlphaStep = (typeof ALPHA_STEPS)[number];

type AlphaStepperProps = {
  activeStep: AlphaStep;
};

export function AlphaStepper({ activeStep }: AlphaStepperProps) {
  const activeIndex = ALPHA_STEPS.indexOf(activeStep);

  return (
    <ol className="flex items-center gap-lg">
      {ALPHA_STEPS.map((step, index) => {
        const isDone = index < activeIndex;
        const isActive = index === activeIndex;

        return (
          <li
            aria-current={isActive ? "step" : undefined}
            className="flex items-center gap-lg"
            key={step}
          >
            {index > 0 && (
              <span
                aria-hidden
                className="h-0.5 w-9 overflow-hidden bg-border-secondary"
              >
                <span
                  className={cn(
                    "block size-full origin-left bg-bg-brand-solid transition-transform duration-500",
                    index <= activeIndex ? "scale-x-100" : "scale-x-0",
                    index === activeIndex &&
                      "motion-safe:animate-alpha-connector",
                  )}
                />
              </span>
            )}
            <span
              className={cn(
                "flex items-center gap-md text-md font-semibold transition-colors duration-300",
                isDone || isActive
                  ? "text-text-brand-primary"
                  : "text-text-quaternary",
              )}
            >
              <span
                className={cn(
                  "grid size-7 place-items-center rounded-full text-sm font-bold transition-colors duration-300",
                  isDone || isActive
                    ? "bg-bg-brand-solid text-white"
                    : "border-2 border-border-secondary",
                  isActive && "motion-safe:animate-alpha-step-pop",
                )}
              >
                {isDone ? <Check size={14} /> : index + 1}
              </span>
              <span className={cn(!isActive && "hidden md:inline")}>
                <span className={cn(!isActive && "hidden md:inline")}>
                  {step}
                </span>
              </span>
            </span>
          </li>
        );
      })}
    </ol>
  );
}
